<div *ngIf="dashBoardPage" class="content">
  <div class="container-fluid">
    <div class="page-title">
      <h1>{{'Dashboard' | translate}}
        <small *ngIf="!powerMaster">
          <a [routerLink]="'/help/dashboard'" target="_blank">
            <i class="fa fa-question-circle" aria-hidden="true"></i>
          </a>
        </small>
      </h1>
      <p>{{refreshTime | date: preferenceService.dateFormat + ' HH:mm:ss'}}</p>
    </div>
    <div class="page-filter flex" style="margin: 0 0 1.5em 0;">
      <div class="tab">
        <p-selectButton *ngIf="statusOptions?.data" [options]="statusOptions.data" [(ngModel)]="selectedStatus" (onChange)="statusChanged()" class="hidden-sm" [allowEmpty]="false">
          <ng-template #item let-item>
            <span>{{item.label | translate}}</span>
            <span class="badge badge-secondary {{item.label}}">{{item.title | translate}}</span>
          </ng-template>
        </p-selectButton>
        <p-select *ngIf="statusOptions?.data" [options]="statusOptions.data" [(ngModel)]="selectedStatusRwd" (onChange)="rwdStatusChanged()" class="select hidden-lg">
            <ng-template let-item pTemplate="selectedItem">
              <span>{{item.label}}</span>
              <span class="badge badge-secondary {{item.label}}">{{item.title}}</span>
            </ng-template>
            <ng-template let-item pTemplate="item">
              <div class="flex">
                <span class="label">{{item.label}}</span>
                <span class="badge badge-secondary {{item.label}}">{{item.title}}</span>
              </div>
            </ng-template>
        </p-select>
      </div>
      <div class="button">
        <div class="filter search">
          <input type="text" pInputText placeholder="{{'Search' | translate}}" [(ngModel)]="searchKeyWord" class="pInputText" (ngModelChange)="onKeywordChange()">
        </div>
        <p-toggleButton class="sortIcon" [(ngModel)]="selectedSort" onIcon="fa fa-sort-alpha-asc" offIcon="fa fa-sort-alpha-desc" onLabel="asc" offLabel="desc"
          (onChange)="onSortChange()"></p-toggleButton>
        <p-selectButton class="selectedView" [options]="view" [(ngModel)]="selectedView" [allowEmpty]="false" *ngIf="!powerMaster">
          <ng-template #item let-item>
            <i [class]="item.icon"></i>
          </ng-template>
        </p-selectButton>
        <button type="button" class="btn btn-outline-dark btn-sm" (click)="refresh()">
          <i class="fa fa-refresh"></i>
        </button>
        <!-- <button type="button" class="btn btn-outline-dark btn-sm" (click)="addGroup()" *ngIf="groupFeature">
          <i class="fa fa-plus"></i>
        </button> -->
        <p-splitButton [model]="items" class="btn btn-outline-dark btn-sm splitbutton"></p-splitButton>
        <!--        <button type="button" class="btn btn-outline-dark btn-sm" (click)="displayAddDeviceDialog=true;dialogMiniCardSaveDirty=false;" *ngIf="powerMaster">-->
        <!--          <i class="fa fa-plus"></i>-->
        <!--        </button>-->
      </div>
    </div>
    <div class="dashBoardTab" *ngIf="!powerMaster">
      <p-tabs [(value)]="selectedTabIndex" (valueChange)="onTabChange($event)">
        <p-tablist>
          <p-tab value="0">{{'All' | translate}}</p-tab>
          <p-tab value="1">{{'Device' | translate}}</p-tab>
          <p-tab value="2">{{'Group' | translate}}</p-tab>
          <p-tab value="3">{{'Shared Device' | translate}}</p-tab>
          <p-tab value="4">{{'Shared Group' | translate}}</p-tab>
        </p-tablist>
      </p-tabs>
    </div>
    <div class="index-content">
      <app-gridview [selectedView]="selectedView" [pageloading]="pageloading" [selectedTab]="selectedTabIndex" [keyWord]="searchKeyWord" [sortType]="selectedSort"></app-gridview>
      <app-listview [selectedView]="selectedView" [pageloading]="pageloading" [selectedTab]="selectedTabIndex" [keyWord]="searchKeyWord" [sortType]="selectedSort"></app-listview>
    </div>
  </div>
</div>

<p-dialog *ngIf="groupFeature" header="{{'Add Group' | translate}}" [(visible)]="display" [modal]="true" [style]="{'width': '450px', 'min-width': '200px', 'top': '70px'}" [baseZIndex]="10000">
  <div class="dialog-content">
    <div class="form-group">
      <label translate>Group Name</label>
      <input type="text" size="30" class="form-control pInputText" pInputText [(ngModel)]="deviceGroupParam.gName" #revInputText="ngModel">
      <p-message severity="error" text="{{'Group Name are required' | translate}}" *ngIf="dialogGroupSaveDirty && !revInputText.value">
      </p-message>
    </div>
    <div class="form-group">
      <label translate>Time Zone</label>
      <div class="select">
        <p-select [options]="timezoneOptions" [(ngModel)]="deviceGroupParam.timeZone" appendTo="body"></p-select>
        <p-message severity="error" text="{{'Please select time zone.' | translate}}"
          *ngIf="groupIsErrorFlag.timeZone && deviceGroupParam.timeZone == null"></p-message>
      </div>
    </div>
    <div class="form-group" *ngIf="isMsp">
      <label translate>Company</label>
      <div class="select">
        <p-select [options]="new_mspCompany_Options_For_Group" [(ngModel)]="deviceGroupParam.companySelectItem" (onChange)="MspCompanyChanged(true)" filter="true"
          placeholder="Select Company" appendTo="body"></p-select>
        <p-message severity="error" text="{{'Please select Company.' | translate}}"
          *ngIf="groupIsErrorFlag.company && deviceGroupParam.companySelectItem == undefined"></p-message>
      </div>
    </div>
    <div class="form-group">
      <label translate>Devices</label>
      <div class="select">
        <p-multiSelect [options]="addDeviceList" [(ngModel)]="deviceGroupParam.deviceSelectItem" [placeholder]="'Choose' | translate" required appendTo="body">
        </p-multiSelect>
      </div>
    </div>
    <div translate class="alert alert-warning">
      Notices !!! The time zone of selected devices will be set as same with Group's time zone.
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton (click)="addGroupSave()" label="{{'Save' | translate}}" class="{{Confirm_button}}"></button>
    <button type="button" pButton (click)="resetGroupField();this.display = false" label="{{'Cancel' | translate}}" class="p-button-secondary"></button>
  </ng-template>
</p-dialog>


<!--<p-dialog header="{{'Add Device' | translate}}" [(visible)]="displayAddDeviceDialog" [modal]="true" [style]="{'width': '450px','min-width': '200px', 'top': '70px'}"-->
<!-- [baseZIndex]="10000">-->
<!--  <div class="dialog-content">-->
<!--    <div class="form-group">-->
<!--      <label translate>Card MAC</label>-->
<!--      <input type="text" size="30" class="form-control pInputText" [(ngModel)]="miniCardParams.mac" pInputText #macInputText="ngModel">-->
<!--      <p-message severity="error" text="{{'Group Name are required' | translate}}" *ngIf="dialogMiniCardSaveDirty && !macInputText.value"></p-message>-->
<!--    </div>-->
<!--    <div class="form-group">-->
<!--      <label translate>Key</label>-->
<!--      <div class="select">-->
<!--        <input type="text" size="30" class="form-control pInputText" style="text-transform:uppercase" [(ngModel)]="miniCardParams.key" pInputText #keyInputText="ngModel">-->
<!--        <p-message severity="error" text="{{'Group Name are required' | translate}}" *ngIf="dialogMiniCardSaveDirty && !keyInputText.value"></p-message>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--  <p-footer>-->
<!--    <button type="button" pButton label="{{'Save' | translate}}" class="{{Confirm_button}}" (click)="addDeviceSave()"></button>-->
<!--    <button type="button" pButton label="{{'Cancel' | translate}}" class="p-button-secondary"-->
<!--            (click)="this.displayAddDeviceDialog=false;"></button>-->
<!--  </p-footer>-->
<!--</p-dialog>-->

<p-dialog header="{{RWCCdialogHeader}}" [(visible)]="RWCCdisplay" [modal]="true" [style]="{'width': '450px', 'min-width': '200px', 'top': '70px'}" [baseZIndex]="10000" [closable]="false"
  class="setupDialog">
  <div class="dialog-content">
    <p-steps [(activeIndex)]="RWCCTabIndex" [readonly]="true"></p-steps>
    <section *ngIf="RWCCTabIndex === 0" class="grid">
      <div class="content-info">
        <h5 *ngIf="!powerMaster" translate>PowerPanel Cloud is ready for setup.</h5>
        <h5 *ngIf="powerMaster" translate>Cloud is ready for setup.</h5>
      </div>
    </section>
    <section *ngIf="RWCCTabIndex === 1" class="grid">
      <div class="setupBox" *ngIf="!powerMaster">
        <div class="setupImg">
          <img class="responsive-image" src="../../../assets/images/RWCC.gif" (click)="LEDStatus.toggle($event)">
        </div>
        <div class="setupInfo">
          <p-popover #LEDStatus [dismissable]="false" [baseZIndex]="11000" [showCloseIcon]="true" [style]="{ 'max-width': '400px' }">
            <div class="table-responsive sec" style="margin-top: 0;">
              <div class="h5" translate>LED Status(Color)</div>
              <div class="css-table">
                <div class="tbody">
                  <div class="tr">
                    <div class="td title" translate>Blue(Flashing)</div>
                    <div class="td" translate>The Remote Wireless Cloud Card is not connected to the Router.</div>
                  </div>
                  <div class="tr">
                    <div class="td title" translate>Green(Flashing)</div>
                    <div class="td" translate>The Remote Wireless Cloud Card is being connected to the Network.</div>
                  </div>
                  <div class="tr">
                    <div class="td title" translate>Green</div>
                    <div class="td" translate>The Remote Wireless Cloud Card is connected to the Network.</div>
                  </div>
                </div>
              </div>
            </div>
          </p-popover>
        </div>
      </div>
      <div class="" [ngClass]="{'alert alert-warning': !powerMaster}">
        <ol class="setupList">
          <li *ngIf="!powerMaster" translate>Make sure the LED indicator of Remote Wireless Cloud Card is flashing blue</li>
          <li *ngIf="powerMaster" translate>Make sure the LED indicator of CMCARD-W is flashing blue</li>
          <li translate>If not, press reset button until it turns flashing blue</li>
        </ol>
      </div>
    </section>
    <section *ngIf="RWCCTabIndex === 2" class="grid">
      <h5 *ngIf="!powerMaster" translate>Connect your computer to your RWCC</h5>
      <h5 *ngIf="powerMaster" translate>Connect your computer to your CMCARD-W</h5>
      <div class="setupImg">
        <img *ngIf="!powerMaster" class="responsive-image" src="../../../assets/images/WiFi.png">
        <img *ngIf="powerMaster" class="responsive-image" src="../../../assets/images/WiFi_CMCARD.png">
      </div>
      <div class="alert alert-warning">
        <p *ngIf="!powerMaster" translate>Go to your WiFi settings on this computer and select the network of the format Cyber_XXX. It may take a while to display. After connecting to Cyber_XXX, you
          can continue setup.</p>
        <p *ngIf="powerMaster" translate>Go to your WiFi settings on this computer and select the network of the format CMCARD_XXXXX. It may take a while to display. After connecting to CMCARD_XXXXX,
          you can continue setup.</p>
      </div>
    </section>
    <section *ngIf="RWCCTabIndex === 3" class="grid">
      <h5 translate>Select your Wi-Fi Network</h5>
      <p-blockUI [target]="blockWiFi" [blocked]="blockedPanel" class="blockWiFi">
        <i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i>
      </p-blockUI>
      <p-panel #blockWiFi class="wifiPanel">
        <p-listbox class="wifiList" [options]="WiFiNetworkList" [(ngModel)]="selectedWiFiNetwork" optionLabel="label" [listStyle]="{'height':'250px'}"></p-listbox>
      </p-panel>
    </section>
    <section *ngIf="RWCCTabIndex === 4" class="grid">
      <h5 translate>Select your Wi-Fi Network</h5>
      <div class="form-group">
        <label translate for="" class="col-form-label" translate>Network</label>
        <div>
          <input type="text" class="form-control pInputText" pInputText disabled [(ngModel)]="selectedWiFiNetwork.value">
        </div>
      </div>
      <div class="form-group">
        <label translate for="" class="col-form-label" translate>Password</label>
        <div>
          <input type="password" pPassword class="form-control pInputText" required [(ngModel)]="WiFipassword" [disabled]="selectedWiFiNetwork.password === 0">
        </div>
      </div>
    </section>
    <section *ngIf="RWCCTabIndex === 5" class="grid">
      <h5 translate>Please wait</h5>
      <p translate>Please wait while we connect your device to the Internet. This may take a few minutes.</p>
      <p-progressBar mode="indeterminate" [style]="{'height': '6px','margin': '2em 0 1em 0'}"></p-progressBar>
    </section>
    <section *ngIf="RWCCTabIndex === 6" class="grid">
      <h5 translate>Please enter your device name</h5>
      <div class="form-group">
        <label translate>Device Name</label>
        <input type="text" class="form-control pInputText" pInputText [(ngModel)]="RWCCDeviceName">
      </div>
    </section>
  </div>
  <ng-template #footer *ngIf="RWCCTabIndex !== 5">
    <section *ngIf="RWCCTabIndex === 0">
      <button type="button" pButton (click)="this.ChangStepWifiCards(1)" label="{{'Continue' | translate}}" class="{{Confirm_button}}"></button>
      <button type="button" pButton (click)="this.RWCCdisplay = false" label="{{'Cancel' | translate}}" class="p-button-secondary"></button>
    </section>
    <section *ngIf="RWCCTabIndex === 1">
      <button type="button" pButton (click)="this.ChangStepWifiCards(2);" label="{{'Continue' | translate}}" class="{{Confirm_button}}"></button>
      <button type="button" pButton (click)="this.ChangStepWifiCards(0)" label="{{'Previous' | translate}}" class="p-button-secondary"></button>
    </section>
    <section *ngIf="RWCCTabIndex === 2">
      <button type="button" pButton (click)="this.ChangStepWifiCards(1)" label="{{'Previous' | translate}}" class="p-button-secondary"></button>
    </section>
    <section *ngIf="RWCCTabIndex === 3">
      <button type="button" pButton (click)="this.ChangStepWifiCards(4); this.WiFipassword = '';" label="{{'Continue' | translate}}" class="{{Confirm_button}}"
        [disabled]="selectedWiFiNetwork == null"></button>
      <button type="button" pButton (click)="refreshWifiList();" label="{{'Refresh' | translate}}" class="{{Confirm_button}}" [disabled]="blockedPanel"></button>
      <button type="button" pButton (click)="this.ChangStepWifiCards(2);" label="{{'Previous' | translate}}" class="p-button-secondary"></button>
    </section>
    <section *ngIf="RWCCTabIndex === 4">
      <button type="button" pButton (click)="this.ChangStepWifiCards(5);" label="{{'Continue' | translate}}" class="{{Confirm_button}}"
        [disabled]="!!!WiFipassword && selectedWiFiNetwork.password === 1"></button>
      <button type="button" pButton (click)="this.ChangStepWifiCards(3); this.selectedWiFiNetwork = null;" label="{{'Choose a different network' | translate}}" class="p-button-secondary"></button>
    </section>
    <section *ngIf="RWCCTabIndex === 6">
      <button type="button" pButton (click)="saveRWCCDevice();" label="{{'Continue' | translate}}" class="{{Confirm_button}}" [disabled]="!!!RWCCDeviceName"></button>
    </section>
  </ng-template>
</p-dialog>

<p-dialog header="{{RCCdialogHeader}}" [(visible)]="RCCdisplay" [modal]="true" [style]="{'width': '450px', 'min-width': '200px', 'top': '70px'}" [baseZIndex]="10000" [closable]="false">
  <div class="dialog-content">
    <p-steps [(activeIndex)]="RCCTabIndex" [readonly]="true"></p-steps>
    <section *ngIf="RCCTabIndex === 0">
      <div class="setupBox" *ngIf="!powerMaster">
        <div class="setupImg" *ngIf="!this.AddDeviceType else RCC_EMBImage">
          <img class="responsive-image" src="../../../assets/images/RCC.png" (click)="LEDcolor.toggle($event)">
        </div>
        <ng-template #RCC_EMBImage>
          <div class="setupImg">
            <img class="responsive-image" src="../../../assets/images/CloudUPS.png" (click)="LEDcolor.toggle($event)">
          </div>
        </ng-template>
        <div class="setupInfo">
          <p-popover #LEDcolor [baseZIndex]="11000" [showCloseIcon]="true" [style]="{ 'max-width': '400px' }">
            <div class="table-responsive">
              <div class="h5" translate>Link LED Color</div>
              <div class="css-table">
                <div class="tbody" *ngIf="!this.AddDeviceType else Link_LED_Color_EMB">
                  <div class="tr">
                    <div class="td title" translate>Off</div>
                    <div class="td" translate>The Remote Cloud Card is not connected to the Network/ or the Remote Cloud Card power is off.</div>
                  </div>
                  <div class="tr">
                    <div class="td title" translate>On(Yellow)</div>
                    <div class="td" translate>The Remote Cloud Card is connected to the Network.</div>
                  </div>
                </div>
                <ng-template #Link_LED_Color_EMB>
                  <div class="tbody">
                    <div class="tr">
                      <div class="td title" translate>Off</div>
                      <div class="td" translate>The Cloud UPS is not connected to the Network/ or the Cloud UPS power is off.</div>
                    </div>
                    <div class="tr">
                      <div class="td title" translate>On(Yellow)</div>
                      <div class="td" translate>The Cloud UPS is connected to the Network.</div>
                    </div>
                  </div>
                </ng-template>
              </div>
            </div>
            <div class="table-responsive sec">
              <div class="h5" translate>Tx/Rx LED Color</div>
              <div class="css-table">
                <div class="tbody" *ngIf="!this.AddDeviceType else RC_LED_Color_EMB">
                  <div class="tr">
                    <div class="td title" translate>Off</div>
                    <div class="td" translate>The Remote Cloud Card power is off.</div>
                  </div>
                  <div class="tr">
                    <div class="td title" translate>On(Green)</div>
                    <div class="td" translate>The Remote Cloud Card power is on.</div>
                  </div>
                  <div class="tr">
                    <div class="td title" translate>Flashing</div>
                    <div class="td">
                      <ul class="setupList">
                        <li translate>Receiving / transmitting data packet</li>
                        <li translate>Reset finished</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <ng-template #RC_LED_Color_EMB>
                  <div class="tbody">
                    <div class="tr">
                      <div class="td title" translate>Off</div>
                      <div class="td" translate>The Cloud UPS power is off.</div>
                    </div>
                    <div class="tr">
                      <div class="td title" translate>On(Green)</div>
                      <div class="td" translate>The Cloud UPS power is on.</div>
                    </div>
                    <div class="tr">
                      <div class="td title" translate>Flashing</div>
                      <div class="td">
                        <ul class="setupList">
                          <li translate>Receiving / transmitting data packet</li>
                          <li translate>Reset finished</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </div>
            </div>
          </p-popover>
        </div>
      </div>
      <div class="alert alert-warning">
        <ol class="setupList">
          <li translate>Make sure wire is connected successfully</li>
          <li translate>Tap continue to proceed setup</li>
        </ol>
      </div>
    </section>
    <section *ngIf="RCCTabIndex === 1">
      <div class="setupBox">
        <div class="setupInfo" style="text-align: center;">
          <p-popover #MACOverlayPanel [baseZIndex]="11000" [showCloseIcon]="true" [style]="{ 'max-width': '400px' }">
            <div>
              <div class="row">
                <div class="col-md-6">
                  <span *ngIf="!powerMaster">{{'PowerPanel APP' | translate}}</span>
                  <span *ngIf="powerMaster">{{'PowerMaster APP' | translate}}</span>
                  <img class="responsive-image" src="../../../assets/images/Screen-Mac-01.png">
                </div>
                <div class="col-md-6">{{'Other scan APP' | translate}}<img class="responsive-image" src="../../../assets/images/Screen-Mac-02.png"></div>
              </div>
            </div>
          </p-popover>
          <p-popover #KeyOverlayPanel [baseZIndex]="11000" [showCloseIcon]="true" [style]="{ 'max-width': '400px' }">
            <div>
              <div class="row">
                <div class="col-md-6">
                  <span *ngIf="!powerMaster">{{'PowerPanel APP' | translate}}</span>
                  <span *ngIf="powerMaster">{{'PowerMaster APP' | translate}}</span>
                  <img class="responsive-image" src="../../../assets/images/Screen-Key-01.png">
                </div>
                <div class="col-md-6">{{'Other scan APP' | translate}}<img class="responsive-image" src="../../../assets/images/Screen-Key-02.png"></div>
              </div>
            </div>
          </p-popover>
        </div>
      </div>
      <div class="alert alert-warning">
        <ol class="setupList" *ngIf="!this.AddDeviceType else RCC_EMBDesc">
          <li *ngIf="!powerMaster" translate>Use scan APP (PowerPanel APP recommended) to scan the QR Code on RCCARD</li>
          <li *ngIf="powerMaster" translate>Use scan APP (PowerMaster APP recommended) to scan the QR Code on CMCARD-E</li>
          <li translate>Display MAC and Key</li>
          <li translate>Enter MAC and Key</li>
          <li translate>Tap Continue to proceed setup</li>
        </ol>
        <ng-template #RCC_EMBDesc>
          <ol class="setupList">
            <li translate>Check sticker on the UPS</li>
            <li translate>Find MAC/Key</li>
            <li translate>Enter MAC and Key accordingly</li>
            <li translate>Tap continue to proceed setup</li>
            <li translate>Or you can use PowerPanel app to scan QR code to add device diretly</li>
          </ol>
        </ng-template>
      </div>
      <div class="form-group">
        <label>{{'MAC (12 Digits)' | translate}}
          <span (click)="MACOverlayPanel.toggle($event)" [hidden]="this.AddDeviceType">
            <i class="fa fa fa-info-circle" aria-hidden="true"></i>
          </span>
        </label>
        <p-inputMask [(ngModel)]="MACNumber" mask="** - ** - ** - ** - ** - **" #revInputText="ngModel" [unmask]="true"></p-inputMask>
        <!-- <input type="text" class="form-control pInputText" pInputText [(ngModel)]="MACNumber" #revInputText="ngModel"> -->
        <p-message severity="error" text="{{'MAC are required' | translate}}" *ngIf="dialogMACNumberSaveDirty && !revInputText.value"></p-message>
      </div>
      <div class="form-group">
        <label>{{'Key (20 Digits)' | translate}}
          <span (click)="KeyOverlayPanel.toggle($event)" [hidden]="this.AddDeviceType">
            <i class="fa fa fa-info-circle" aria-hidden="true"></i>
          </span>
        </label>
        <!-- <input type="text" class="form-control pInputText" pInputText [(ngModel)]="KeyNumber" #revInputText="ngModel"> -->
        <p-inputMask [(ngModel)]="KeyNumber" mask="**** - **** - **** - **** - ****" #revInputText="ngModel" [unmask]="true"></p-inputMask>
        <p-message severity="error" text="{{'Key are required' | translate}}" *ngIf="dialogKeyNumberSaveDirty && !revInputText.value"></p-message>
      </div>
      <div class="form-group" *ngIf="isMsp">
        <label translate>Company</label>
        <div class="select">
          <p-select [options]="new_mspCompany_Options_For_Device" [(ngModel)]="RCCCompanySelectItem" [baseZIndex]="10000" filter="true" placeholder="{{'Select Company' | translate}}" appendTo="body"></p-select>
        </div>
      </div>
    </section>
    <section *ngIf="RCCTabIndex === 2">
      <h5 translate>Please enter your device name</h5>
      <div class="form-group">
        <label translate>Device Name</label>
        <input type="text" class="form-control pInputText" pInputText [(ngModel)]="RCCDeviceName">
      </div>
    </section>
  </div>
  <ng-template #footer>
    <section *ngIf="RCCTabIndex === 0" class="grid">
      <button *ngIf="!this.AddDeviceType else RCC_EMB" type="button" pButton (click)="this.RCCTabIndex = 1" label="{{'Continue' | translate}}" class="{{Confirm_button}}"></button>
      <ng-template #RCC_EMB>
        <button type="button" pButton (click)="this.RCCTabIndex = 1" label="{{'Continue' | translate}}" class="{{Confirm_button}}"></button>
      </ng-template>
      <button type="button" pButton (click)="closeRCCDialog($event, LEDcolor)" label="{{'Cancel' | translate}}" class="p-button-secondary"></button>
    </section>
    <section *ngIf="RCCTabIndex === 1" class="grid">
      <button *ngIf="!this.AddDeviceType else RCC_EMBCheck" type="button" pButton (click)="checkRCCMacName();" label="{{'Continue' | translate}}" class="{{Confirm_button}}"
        [disabled]="!!!KeyNumber && !!!MACNumber || KeyNumber.length < 20 || MACNumber.length < 12 || (isMsp && RCCCompanySelectItem == '')"></button>
      <ng-template #RCC_EMBCheck>
        <button type="button" pButton (click)="checkRCCEMBMacName();" label="{{'Continue' | translate}}" class="{{Confirm_button}}"
          [disabled]="!!!MACNumber && !!!KeyNumber || KeyNumber.length < 20 || MACNumber.length < 12 || (isMsp && RCCCompanySelectItem == '')"></button>
      </ng-template>
      <button type="button" pButton (click)="this.RCCTabIndex = 0" label="{{'Previous' | translate}}" class="p-button-secondary"></button>
    </section>
    <section *ngIf="RCCTabIndex === 2" class="grid">
      <button type="button" pButton (click)="saveRCCDeviceName();" label="{{'Continue' | translate}}" class="{{Confirm_button}}" [disabled]="!!!RCCDeviceName"></button>
      <!-- <button *ngIf="!this.AddDeviceType else RCC_EMBSave" type="button" pButton (click)="saveRCCDeviceName();" label="{{'Continue' | translate}}" class="{{Confirm_button}}" [disabled]="!!!RCCDeviceName"></button>
      <ng-template #RCC_EMBSave>
        <button type="button" pButton (click)="saveRCCEMBDeviceName();" label="{{'Continue' | translate}}" class="{{Confirm_button}}" [disabled]="!!!RCCDeviceName"></button>
      </ng-template> -->
    </section>
  </ng-template>
</p-dialog>

<app-dialog (connectEvt)="detectRWCCWiFi($event)"></app-dialog>